import { forwardRef } from 'react';

import MuiInputLabel from '@mui/material/InputLabel';
const InputLabel = forwardRef((props, ref) => {
  return <MuiInputLabel ref={ref} {...props} />;
});
InputLabel.displayName = 'InputLabel';
export default InputLabel;
